// @flow strict

import * as React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { RevenueLineCharts } from "./DashboardEcommerceCharts";
import { useState } from "react";
import { useEffect } from "react";
import { RevenueDataApp } from "../../../common/data";
import Loader from "../../../Components/Common/Loader";

function RevenueLineChart() {
  const [loading, setLoading] = useState(false);
  const [revenueData, setRevenueData] = useState([]);
  const [revenueLabel, setRevenueLabel] = useState([]);
  const [revenuePeriod, setRevenuePeriod] = useState("mois");

  
  // let RevenueDataWeek = RevenueDataApp("semaine");
  // let RevenueDataMonth = RevenueDataApp("mois");
  // let RevenueDataYear = RevenueDataApp("an");

  const fetchDataMonth = async () => {
    setLoading(true);

    const getRevenueDataMonth = await RevenueDataApp("mois");
    // console.log( "getRevenueDataMonth: ", getRevenueDataMonth );
    setRevenueLabel(getRevenueDataMonth.labels);
    setRevenueData(getRevenueDataMonth.data);

    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const fetchDataYear = async () => {
    setLoading(true);
    const getRevenueDataYear = await RevenueDataApp("an");
    // console.log( "getRevenueDataYear: ", getRevenueDataYear );
    setRevenueLabel(getRevenueDataYear.labels);
    setRevenueData(getRevenueDataYear.data);

    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const onChangeChartPeriod = (pType) => {
    // console.log("Période: ", pType);
    // dispatch( getAudiencesMetricsChartsData( pType ) );
    switch (pType) {
      case "an":
        setRevenuePeriod("an");
        fetchDataYear();
        break;
      case "mois":
        setRevenuePeriod("mois");
        fetchDataMonth();
        break;
      case "semaine":
        setRevenuePeriod("semaine");
        fetchDataMonth();
        break;
      default:
        setRevenuePeriod("mois");
        fetchDataMonth();
        break;
    }
  };

  useEffect(() => {
    fetchDataMonth(); // Initial fetch when component mounts
  }, []);

  useEffect(() => {
    // console.log( "Data: ", revenueData );
    // console.log( "Label: ", revenueLabel );
  }, [revenueData, revenueLabel]);

  return (
    <React.Fragment>
      <Col xl={6}>
        <Card>
          <CardHeader className="border-0 align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Revenues</h4>
            <div className="d-flex gap-1">
              <button
                disabled={revenuePeriod === "mois"}
                type="button"
                className="btn btn-soft-secondary btn-sm"
                onClick={() => {
                  onChangeChartPeriod("mois");
                }}
              >
                Mois
              </button>
              <button
                disabled={revenuePeriod === "an"}
                type="button"
                className="btn btn-soft-secondary btn-sm"
                onClick={() => {
                  onChangeChartPeriod("an");
                }}
              >
                An
              </button>
              {/* <button disabled={ revenuePeriod =="semaine"} type="button" className="btn btn-soft-secondary btn-sm" onClick={ () => { onChangeChartPeriod( "semaine" ); } }>
                                Semaine
                            </button> */}
            </div>
          </CardHeader>

          <CardBody>
            <div>
              {!loading ? (
                <RevenueLineCharts
                  period={revenuePeriod}
                  data={revenueData}
                  labels={revenueLabel}
                  dataColors='["--vz-primary"]'
                />
              ) : (
                <div className="text-center my-3">
                  <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
}

export default RevenueLineChart;
